import { destroy } from "./utils/httpUtil";

export const api_DeleteCustomerComany = ({companyId,...params}) =>
    destroy(`Customer/${companyId}`);

export const api_DeleteResellerComany = ({companyId,...params}) =>
    destroy(`Reseller/${companyId}`)